import React, { useMemo, useState, createContext, useEffect } from 'react';

const LatestNewsContext = createContext({});

export function LatestNewsProvider({ children }) {
  const [displayMenu, setDisplayMenu] = useState(false);
  const [displaySelect, setDisplaySelect] = useState(false);
  const [listing, setListing] = useState('grid');
  const [yearsOptions, setYearsOptions] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [option, setOption] = useState(new Date().getFullYear());

  useEffect(() => {
    const getYearsArray = () => {
      const start = 2011;
      const end = new Date().getFullYear();
      const yearsDiff = end - start;
      const yearsArr = new Array(yearsDiff).fill('');
      return yearsArr.map((_, index) => +end - index);
    };

    setYearsOptions(getYearsArray());
  }, []);

  const memo = {
    displayMenu,
    setDisplayMenu,
    displaySelect,
    setDisplaySelect,
    listing,
    setListing,
    yearsOptions,
    toggle,
    setToggle,
    option,
    setOption,
  };

  const value = useMemo(() => memo, [memo]);

  return <LatestNewsContext.Provider value={value}>{children}</LatestNewsContext.Provider>;
}

export default LatestNewsContext;
